import { render, staticRenderFns } from "./UserVideoDisplay.vue?vue&type=template&id=0f81df61&"
import script from "./UserVideoDisplay.vue?vue&type=script&lang=js&"
export * from "./UserVideoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./UserVideoDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports